var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FontAwesomeIcon',_vm._b({class:_vm.colorOfType,attrs:{"icon":_vm.styleIcon ? [_vm.pack, _vm.icon] : _vm.icon}},'FontAwesomeIcon',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }